/**
 * THEME JSON CONFIG CSS VARS
 * The following default component scss variables can be overwritten via theme configuration per brand.
 * If you need to add new one, please make sure to set a default value.
 * JSON Definition for Component with name "Example": testCssVar: "20px"
 * Resulting CSS var: $example-test-css-var: 20px;
 */

/* END THEME JSON CONFIG CSS VARS ******************************************************* */

:host {
  display: block;
}

.#{$prefix}list-wrapper {
  position: relative;

  .#{$prefix}list {
    position: relative;
    min-height: 250px;
    display: grid;
    grid-template-columns: auto;
    grid-gap: 10px;
    opacity: 1;
    transition: opacity 0.2s ease;
  }

  .#{$prefix}paging {
    display: grid;
    grid-template-columns: auto auto auto;
    padding-top: 32px;
    opacity: 1;
    transition: opacity 0.2s ease;

    @include for-size(phone) {
      grid-template-columns: auto;
      grid-template-areas:
        "top"
        "bottom";
      gap: 24px;
    }

    @include for-size(desktop-or-smaller) {
      padding-top: 24px;
    }

    &__column {
      white-space: nowrap;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;

      eon-ui-dropdown {
        width: 100px;
      }

      eon-ui-input {
        width: 55px;
      }

      &--mobile-top {
        @include for-size(phone) {
          grid-area: top;
        }
      }

      &--mobile-bottom {
        @include for-size(phone) {
          grid-area: bottom;
        }
      }

      &--hide-mobile {
        @include for-size(phone) {
          display: none;
        }
      }

      &--mobile-100 {
        @include for-size(phone) {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
        }
      }

      &--pagination {
        @include for-size(tablet) {
          grid-area: 1/3;
        }

        @include for-size(phone) {
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          grid-area: top;
        }
      }

      &--pagination-text {
        @include for-size(tablet) {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          grid-area: 2/1;
          margin-top: 24px;
        }
      }
    }

    &__column:nth-child(1) {
      @include for-size(tablet-or-larger) {
        justify-content: flex-start;
      }
    }

    &__column:nth-last-child(1) {
      @include for-size(tablet-or-larger) {
        justify-content: flex-end;
        grid-area: 1/3;
      }
    }

    &__items__label {
      margin-right: 8px;
    }

    &__items__control {
      width: 73px;
    }

    &__current__input {
      width: 53px;
      margin-left: 18px;
      margin-right: 8px;

      @include for-size(phone) {
        margin-left: 43px;
      }
    }

    &__current__label {
      margin-right: 43px;
    }
  }

  .#{$prefix}pagination {
    display: flex;
    font-family: $font-family-base;
  }

  .#{$prefix}pagination-element {
    padding: 6px;
    margin: 0 2px;
    border-radius: 5px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    width: 24px;

    &.#{$prefix}disabled {
      pointer-events: none;
    }

    &.#{$prefix}active {
      background: v(paginationActiveBackground);
      color: v(paginationActiveColor);
    }

    &:hover:not(.#{$prefix}disabled) {
      background: v(paginationHoverBackground);
      color: v(paginationHoverColor);
      --contentHoverColor: var(--paginationHoverColor);
      --contentColor: var(--paginationHoverColor);
      transition: none;
    }
  }

  .#{$prefix}paging__current-button {
    padding: 2px 6px;
  }

  .#{$prefix}preloading-overlay {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    z-index: 99;
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.2s ease, visibility 0.2s ease;
  }

  &.#{$prefix}loading {
    .#{$prefix}list {
      opacity: 0.1;
    }

    .#{$prefix}paging {
      opacity: 0.1;
    }

    .#{$prefix}preloading-overlay {
      opacity: 1;
      visibility: visible;
    }
  }
}

::slotted([slot="preloader"]) {
  position: sticky;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  margin: 150px 0 150px 0;
}
